export const DEFAULT_AUTO_HIDE_DURATION = 30000
